import axios from 'axios';

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjU5ZGQ4NWRjLWVjMmQtNDllYy04Nzk0LWJjMGZlNzQxMGViMCIsIm5hbWUiOiJMdWl6IENvcnJlaWEiLCJlbWFpbCI6Imx1aXpAbHVpemNvcnJlaWEuZXRpLmJyIiwicm9sZUlkIjoiYTA4ZDdmOWQtMWM3OS00YWI1LWE1ZGQtNWUwMzUyYzJkZmU2IiwiaWF0IjoxNjA1Nzk1MzQ1LCJleHAiOjE5MjExNTUzNDV9.DVLcC8aWa3T3Yxp3wVHBbQHayMTKsj9xBUrXLAmeevI";

const tokenGeradoParaFabrika = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjUyYzgxYmZmLWE5ZDMtNDRiYi04MTZlLWZkMmE2OGVhYTA5ZCIsIm5hbWUiOiJmYWJyaWthIiwiZW1haWwiOiJmYWJyaWthQGZhYnJpa2EuY29tLmJyIiwicm9sZUlkIjoiYTA4ZDdmOWQtMWM3OS00YWI1LWE1ZGQtNWUwMzUyYzJkZmU2IiwiaWF0IjoxNjA2MjUwNzk5LCJleHAiOjE5MjE2MTA3OTl9.cfAfK9TI9JIzizT-pDgnDlWq4qSUrIP8zBhtzbOPYqQ";

export const api = axios.create({
    baseURL: 'https://apicci.qira.com.br/v1', //Produção
    //baseURL: 'http://localhost:3001/v1',
    // baseURL: 'https://apihom.correios.com.br/v1',
    // baseURL: 'https://api.qira.com.br/v1',
    //baseURL: 'http://52.202.208.40:3001/v1',
    //baseURL: 'https://sandboxcci.qira.com.br/v1', //Sandbox

    headers: { 
        'authorization' : `Bearer ${tokenGeradoParaFabrika}`, 
        // 'Access-Control-Allow-Origin': '*', 
        // 'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS', 
        // "Access-Control-Allow-Credentials": "true",
        // 'Content-Type': 'application/json;charset=utf-8'
    },
    timeout: 50000, // Set a timeout of 5 seconds
});



export default {
    api,
}